/**
 * Toolbar
 *  Contains just the logout button for now.
 *
 * @depends jquery.js
 * @depends extendClass.js
 *
 */
/*global Klazz, diy, jimdoData, jQuery, systemurl */
var $ = require('jquery');

var Administration = Klazz.extend({
    contextType: '', /* possible values: editor, web */
    toolbar: null,
    options: {
        classSelected: 'selected'
    },
    messages: {
        logoutLabel: jimdoData.messages.logout,
        tooltipLogout: ''
    },
    element: null,
    setup: function() {
        this.contextType = diy.context.type;
        this.messages = $.extend(true, {}, this.messages, jimdoData.messages.toolbar); // note: we break object reference
        this.options = $.extend(true, {}, this.options); // note: we break object reference
    },
    initialize: function(toolbar) {
        this.toolbar = toolbar;
        this.setup();
        this.draw();
    },
    draw: function(){
        var self = this,
            elementHtml = '',
            isTouchEnabled = diy.context.type === 'editor' ? diy.editor.uiPreference.isPointerModeTouch() :
                Modernizr.touch,
            elementInnerText = isTouchEnabled ?
                '<span class="icon" />'
                :
                this.messages.logoutLabel;

        elementHtml += '<div id="administrationContainer">';
        elementHtml += '<div class="label logout" title="'+
            this.messages.tooltipLogout +
            '">' +
            elementInnerText +
            '</div>';
        elementHtml += '</div>';

        this.element = this.toolbar.pushToPanel('right', elementHtml);

        // activate the logout button //
        this.element.find('.logout').click(function () {
            switch (self.contextType) {
                case 'editor':
                    window.logout();
                    break;
                case 'web':
                    window.location = systemurl + 'app/cms/logout.php';
                    break;

                case 'mobilepreview':
                    window.location = systemurl + 'app/cms/logout.php?no_referer=1';
                    break;
            }
        });
    }
 });

module.exports = Administration;



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/administration.js
 ** module id = 845
 ** module chunks = 0 9 10
 **/